function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "icons/basic/mail"
}, React.createElement("path", {
  id: "Union",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.53333 11.4502C8.53333 11.4502 14.973 15.1021 16.2229 15.1021C17.533 15.1021 23.9029 11.52 23.9029 11.52L23.9132 10.88C23.9132 10.1735 23.3397 9.59998 22.6313 9.59998H9.81461C9.10677 9.59998 8.53333 10.1735 8.53333 10.88V11.4502ZM23.9029 13.4401C23.9029 13.4401 17.5932 16.8621 16.2229 16.8621C14.973 16.8621 8.54293 13.4401 8.54357 13.4401L8.53333 21.1201C8.53333 21.8267 9.10741 22.4 9.81461 22.4H22.6313C23.3397 22.4 23.9132 21.8267 23.9132 21.1201L23.9029 13.4401Z",
  fill: "#222222"
}));

var SvgMail = function SvgMail(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb25zL2Jhc2ljL21haWwiPgo8cGF0aCBpZD0iVW5pb24iIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC41MzMzMyAxMS40NTAyQzguNTMzMzMgMTEuNDUwMiAxNC45NzMgMTUuMTAyMSAxNi4yMjI5IDE1LjEwMjFDMTcuNTMzIDE1LjEwMjEgMjMuOTAyOSAxMS41MiAyMy45MDI5IDExLjUyTDIzLjkxMzIgMTAuODhDMjMuOTEzMiAxMC4xNzM1IDIzLjMzOTcgOS41OTk5OCAyMi42MzEzIDkuNTk5OThIOS44MTQ2MUM5LjEwNjc3IDkuNTk5OTggOC41MzMzMyAxMC4xNzM1IDguNTMzMzMgMTAuODhWMTEuNDUwMlpNMjMuOTAyOSAxMy40NDAxQzIzLjkwMjkgMTMuNDQwMSAxNy41OTMyIDE2Ljg2MjEgMTYuMjIyOSAxNi44NjIxQzE0Ljk3MyAxNi44NjIxIDguNTQyOTMgMTMuNDQwMSA4LjU0MzU3IDEzLjQ0MDFMOC41MzMzMyAyMS4xMjAxQzguNTMzMzMgMjEuODI2NyA5LjEwNzQxIDIyLjQgOS44MTQ2MSAyMi40SDIyLjYzMTNDMjMuMzM5NyAyMi40IDIzLjkxMzIgMjEuODI2NyAyMy45MTMyIDIxLjEyMDFMMjMuOTAyOSAxMy40NDAxWiIgZmlsbD0iIzIyMjIyMiIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgMail as ReactComponent };